/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import moment from 'jalali-moment'
import Swal from 'sweetalert2'

import './Order.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { useNavigate } from 'react-router-dom'

import { get, post } from '../../services/https'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'
import { ToRial } from '../../services/money'

export default function index() {
  const navigate = useNavigate()

  const [orders, setOrders] = useState([])

  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        get(`/api/front/users/${response.data.data.userId}`)
          .then(responseUser => {
            get(`/api/front/order/user/${responseUser.data.data._id}`)
              .then(responseOrderUser => {
                setOrders(responseOrderUser.data.data)
              })
          }).catch(error => {
            notify('error', 'ابتدا ثبت نام / ورود کنید')
            setTimeout(() => {
              navigate('/login')
            }, 3000)
          })
      }).catch(error => {
        // notify('error', 'ابتدا ثبت نام / ورود کنید')
        Swal.fire({
          icon: "error",
          title: "ابتدا ثبت نام کنید یا وارد شوید",
          text: "",
          footer: '<a href="#">در صورت مشکل با پشتیبانی در تماس باشید</a>'
        })
        setTimeout(() => {
          navigate('/login')
        }, 3000)
      })
  }, [navigate])

  const seeOrderDetailsHandler = (e) => {
    navigate(`/order/details/${e.target.id}`)
  }

  return (
    <div id='order'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
        <div className='body'>
        </div>
        <div className="scroll">
          <div className='orderTitle'>سفارشات</div>
          {orders ? orders.map(item => (
            <div key={item._id} className='orderCard'>
              <div className='date'>
                {moment(item.updatedAt).locale('fa').format('YYYY/MM/DD HH:mm')}
              </div>
              <div className='orderNumber'>
                شماره سفارش : {item.orderNumber}
              </div>
              <div className='item'>
                <span>جمع سفارش :</span>
                <span>{ToRial(String(item.total))} تومان</span>
              </div>
              <div className='item'>
                <span>اقلام :</span>
                <span>{item.productsCount} مورد</span>
              </div>
              <div className='item'>
                <span>وضعیت :</span>
                <span className='situation active'>{item.orderStatus === 'new' ? 'سفارش جدید' : ''}{item.orderStatus === 'doing' ? 'در حال انجام' : ''}{item.orderStatus === 'ready' ? 'سفارش آماده تحویل' : ''}{item.orderStatus === 'done' ? 'سفارش تحویل داده شده است' : ''}{item.orderStatus === 'cancel' ? 'سفارش کنسل شده است' : ''}</span>
              </div>
              <div className='item'>
                <span></span>
                <span className='more' id={item._id} onClick={seeOrderDetailsHandler}>جزئیات ...</span>
              </div>
            </div>
          )) : 'در حال لود'}
          {orders.length === 0 ? (
            <div className='orderCard'>
              سفارشی موجود نیست
            </div>
          ) : ''}
        </div>
      <Footer page={'order'} />
    </div>
  )
}
